// removed by extract-text-webpack-plugin
module.exports = {"overlay":"landing-overlay-rM9U9_0","login_bg":"landing-login_bg-1_eWB_0","loginBg":"landing-login_bg-1_eWB_0","center":"landing-center-16YsQ_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[name]-[local]-[hash:base64:5]_0","importLoaders":true,"camelCase":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-187fd66a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/others/landing.vue
// module id = Qzoi
// module chunks = 1